import { productEntitlementsSchema } from '@inkitt/contracts-common';
import { z } from 'zod';
import { booleanQueryParam, c } from '../../contract';
import { productsQuerySchema } from '../../utils/productsQuery';

export const adminRouter = c.router(
  {
    getUserSubscriptions: {
      summary: 'Get user subscriptions',
      method: 'GET',
      path: '/subscriptions',
      query: z.object({
        userId: z.string().min(1),
        callSource: z.string(),
        stripeCustomerId: z.string().optional(),
        bypassCache: booleanQueryParam.optional(),
        products: productsQuerySchema,
      }),
      responses: {
        200: productEntitlementsSchema,
      },
    },
  },
  { pathPrefix: '/admin' },
);
